export default __webpack_public_path__ + "static/media/dog-image.3a2846a5.jpg";